import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
	interviewRoundsGet,
	interviewRoundGetById,
	interviewRoundCreate,
	interviewRoundUpdate,
	interviewRoundComplete,
	interviewRoundGenerate,
	interviewRoundEvaluate,
	interviewRoundDelete
} from "api/menu/hr/interviews/requests";

export const FETCH_INTERVIEW_ROUNDS_SUCCESS = "FETCH_INTERVIEW_ROUNDS_SUCCESS";
export const FETCH_INTERVIEW_ROUND_BY_ID_SUCCESS = "FETCH_INTERVIEW_ROUND_BY_ID_SUCCESS";
export const INTERVIEW_ROUNDS_REQUEST_LOADING = "INTERVIEW_ROUNDS_REQUEST_LOADING";
export const INTERVIEW_ROUNDS_REQUEST_ERRORS = "INTERVIEW_ROUNDS_REQUEST_ERRORS";
export const INTERVIEW_ROUND_GENERATE_LOADING = "INTERVIEW_ROUND_GENERATE_LOADING";
export const INTERVIEW_ROUND_EVALUATE_LOADING = "INTERVIEW_ROUND_EVALUATE_LOADING";

export const setLoading = () => ({ type: INTERVIEW_ROUNDS_REQUEST_LOADING });
export const setGenerateLoading = (loading = true) => ({ type: INTERVIEW_ROUND_GENERATE_LOADING, payload: loading });
export const setEvaluateLoading = (loading = true) => ({ type: INTERVIEW_ROUND_EVALUATE_LOADING, payload: loading });

export const fetchInterviewRounds = (applicantId, includeInactive = false) => dispatch => {
	dispatch(setLoading());
	interviewRoundsGet(applicantId, includeInactive)
		.then(response => {
			dispatch({ type: FETCH_INTERVIEW_ROUNDS_SUCCESS, payload: response.data });
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, INTERVIEW_ROUNDS_REQUEST_ERRORS));
		});
};

export const fetchInterviewRoundById = (applicantId, roundId) => dispatch => {
	interviewRoundGetById(applicantId, roundId)
		.then(response => {
			dispatch({ type: FETCH_INTERVIEW_ROUND_BY_ID_SUCCESS, payload: response.data });
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, INTERVIEW_ROUNDS_REQUEST_ERRORS));
		});
};

export const createInterviewRound = (applicantId, data, callback = false) => dispatch => {
	dispatch(formErrorLoading());
	interviewRoundCreate(applicantId, data)
		.then(response => {
			dispatch(formErrorLoading(false));
			toast("Interview round created", { type: toast.TYPE.SUCCESS });
			if (callback) callback(response.data);
		})
		.catch(error => {
			dispatch(formErrorsHandler(error));
		});
};

export const updateInterviewRound = (applicantId, roundId, data, callback = false) => dispatch => {
	dispatch(formErrorLoading());
	interviewRoundUpdate(applicantId, roundId, data)
		.then(response => {
			dispatch(formErrorLoading(false));
			toast("Interview draft saved", { type: toast.TYPE.SUCCESS });
			if (callback) callback(response.data);
		})
		.catch(error => {
			dispatch(formErrorsHandler(error));
		});
};

export const completeInterviewRound = (applicantId, roundId, data, callback = false) => dispatch => {
	dispatch(formErrorLoading());
	interviewRoundComplete(applicantId, roundId, data)
		.then(response => {
			dispatch(formErrorLoading(false));
			toast("Interview completed", { type: toast.TYPE.SUCCESS });
			if (callback) callback(response.data);
		})
		.catch(error => {
			dispatch(formErrorsHandler(error));
		});
};

export const generateInterviewRound = (applicantId, data = {}, callback = false) => dispatch => {
	dispatch(setGenerateLoading(true));
	interviewRoundGenerate(applicantId, data)
		.then(response => {
			dispatch(setGenerateLoading(false));
			toast("Interview round created using AI", { type: toast.TYPE.SUCCESS });
			if (callback) callback(response.data);
		})
		.catch(error => {
			dispatch(setGenerateLoading(false));
			dispatch(defaultErrorHandler(error, INTERVIEW_ROUNDS_REQUEST_ERRORS));
		});
};

export const evaluateInterviewRound = (applicantId, roundId, callback = false) => dispatch => {
	dispatch(setEvaluateLoading(true));
	interviewRoundEvaluate(applicantId, roundId)
		.then(response => {
			dispatch(setEvaluateLoading(false));
			toast("Post-interview AI assessment completed", { type: toast.TYPE.SUCCESS });
			if (callback) callback(response.data);
		})
		.catch(error => {
			dispatch(setEvaluateLoading(false));
			dispatch(defaultErrorHandler(error, INTERVIEW_ROUNDS_REQUEST_ERRORS));
		});
};

export const deleteInterviewRound = (applicantId, roundId, callback = false) => dispatch => {
	dispatch(setLoading());
	interviewRoundDelete(applicantId, roundId)
		.then(() => {
			toast("Interview round deleted", { type: toast.TYPE.SUCCESS });
			if (callback) callback();
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, INTERVIEW_ROUNDS_REQUEST_ERRORS));
		});
};

export const clearInterviewRounds = () => dispatch => {
	dispatch({ type: FETCH_INTERVIEW_ROUNDS_SUCCESS, payload: [] });
};

export const clearSingleInterviewRound = () => dispatch => {
	dispatch({ type: FETCH_INTERVIEW_ROUND_BY_ID_SUCCESS, payload: {} });
};
